import { render } from "./ViewPdf.vue?vue&type=template&id=fc89855a"
import script from "./ViewPdf.vue?vue&type=script&lang=js"
export * from "./ViewPdf.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/share.filevaultcore.com/share.filevaultcore.com/share.filevaultcore.spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__